import { render, staticRenderFns } from "./SchoolClassDocuments.vue?vue&type=template&id=1e7e7ae1"
import script from "./SchoolClassDocuments.vue?vue&type=script&lang=js"
export * from "./SchoolClassDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports